import { Home, Circle, ShoppingCart, Package } from "react-feather";

// eslint-disable-next-line import/no-anonymous-default-export
export default [
  {
    id: "brands",
    title: "BeUni Brands",
    icon: <Package size={20} />,
    children: [
      {
        id: "Catalogue",
        title: "Catalogue",
        icon: <ShoppingCart size={20} />,
        navLink: "/brands/catalogo",
        action: "true",
        resource: "brands_free_navigation",
      },
      {
        id: "Budget",
        title: "Orçamento",
        icon: <Circle size={12} />,
        navLink: "/brands/budget",
        action: "true",
        resource: "brands_free_navigation",
      },
      {
        id: "Stock",
        title: "Estoque",
        icon: <Circle size={12} />,
        navLink: "/brands/estoque",
        action: "true",
        resource: "brands_free_navigation",
      },
      {
        id: "packages",
        title: "Pacotes",
        icon: <Circle size={12} />,
        navLink: "/brands/pacotes",
        action: "true",
        resource: "brands_free_navigation",
      },
      {
        id: "Shippings",
        title: "Envios",
        icon: <Circle size={12} />,
        navLink: "/brands/envios",
        action: "true",
        resource: "brands_free_navigation",
      },
      // {
      //   id: 'quotation',
      //   title: 'aprove quotation',
      //   icon: <Circle />,
      //   navLink: '/brands/cotation/approve-quotations/547',
      //   action: 'true',
      //   resource: 'brands_free_navigation',

      // },
      {
        id: "SentItems",
        title: "Entregas",
        icon: <Circle size={12} />,
        navLink: "/brands/entregas",
        action: "true",
        resource: "brands_free_navigation",
      },
      {
        id: "Balance",
        title: "Saldo",
        icon: <Circle size={12} />,
        navLink: "/brands/saldo",
        action: "true",
        resource: "brands_free_navigation",
      },
    ],
  },
];
